module.exports = __webpack_public_path__ + "static/media/icon_only_check.e7766890.svg";